<template>
  <div>
    <div>
      <CRow>
        <CCol>
          <CForm @submit.prevent="scalePods">
            <CCard>
              <CCardHeader>Scale Pods Number</CCardHeader>
              <CCardBody>
                <CRow>
                  <!-- Left Column - API Pods -->
                  <CCol md="4">
                    <CInput
                      v-model="pods.v3Api"
                      label="V3 API Deployment"
                      disabled
                    />
                  </CCol>
                  <CCol md="4">
                    <CInput
                      v-model="pods.v3ApiTrack"
                      label="V3 API Track Deployment"
                      disabled
                    />
                  </CCol>
                  <CCol md="4">
                    <CInput
                      v-model="pods.feedApi"
                      label="Feed API Deployment"
                      disabled
                    />
                  </CCol>
                  <CCol md="6">
                    <CInput
                      v-model="interval"
                      label="Time (Minutes) Until Pods Are Scaled Down"
                      disabled
                    />
                  </CCol>

                  <CCol md="6">
                    <CSelect
                      v-model="scaleOption"
                      :options="scaleOptions"
                      label="Scale Options"
                    />
                  </CCol>

                  <CCol
                    md="6"
                    v-if="scaleOption === 'Scale Later'"
                    class="mb-3"
                  >
                    <label>Scale Up At</label>
                    <vc-date-picker
                      v-model="scaleRange.scaleUpAt"
                      mode="dateTime"
                      :popover="false"
                      :masks="{ inputDateTime24hr: 'YYYY-MM-DD HH:mm' }"
                      :model-config="{
                        type: 'string',
                        mask: 'YYYY-MM-DD HH:mm',
                      }"
                      is24hr
                    >
                      <template
                        v-slot="{ inputValue, inputEvents, togglePopover }"
                      >
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span
                              class="input-group-text"
                              @click="togglePopover"
                            >
                              <CIcon name="cil-calendar"></CIcon>
                            </span>
                          </div>
                          <input
                            class="form-control"
                            :value="inputValue"
                            v-on="inputEvents"
                          />
                        </div>
                      </template>
                    </vc-date-picker>
                  </CCol>

                  <CCol
                    md="6"
                    v-if="scaleOption === 'Scale Later'"
                    class="mb-3"
                  >
                    <label>Scale Down At</label>
                    <vc-date-picker
                      v-model="scaleRange.scaleDownAt"
                      mode="dateTime"
                      :popover="false"
                      :masks="{ inputDateTime24hr: 'YYYY-MM-DD HH:mm' }"
                      :model-config="{
                        type: 'string',
                        mask: 'YYYY-MM-DD HH:mm',
                      }"
                      is24hr
                      class="mb-1"
                    >
                      <template v-slot="{ inputValue, inputEvents }">
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">
                              <CIcon name="cil-calendar"></CIcon>
                            </span>
                          </div>
                          <input
                            class="form-control"
                            :value="inputValue"
                            v-on="inputEvents"
                            disabled
                          />
                        </div>
                      </template>
                    </vc-date-picker>
                  </CCol>
                </CRow>

                <!-- Submit Button - Full Width Below Columns -->
                <CRow class="mt-3">
                  <CCol>
                    <CButton
                      block
                      color="warning"
                      type="submit"
                      variant="outline"
                      >Submit</CButton
                    >
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard>
          </CForm>
        </CCol>
      </CRow>

      <CRow>
        <CCol>
          <PNScalePodSchedule ref="pnScalePodSchedule" />
        </CCol>
      </CRow>
    </div>
  </div>
</template>

<script>
import format from 'date-fns/format';
import addMinutes from 'date-fns/addMinutes';
import { SCALED_PODS } from '@/constant/constants';
import PNScalePodSchedule from './PNScalePodSchedule.vue';
export default {
  name: 'PNScalePods',
  components: { PNScalePodSchedule },
  data() {
    const now = new Date();
    return {
      pods: {
        v3Api: SCALED_PODS.v3_scaled_pod,
        v3ApiTrack: SCALED_PODS.v3_track_scaled_pod,
        feedApi: SCALED_PODS.feed_api_scaled_pod,
      },
      interval: 30,
      scaleOptions: ['Scale Now', 'Scale Later'],
      scaleOption: 'Scale Now',
      scaleRange: {
        scaleUpAt: now,
        scaleDownAt: addMinutes(now, 30),
      },
    };
  },
  watch: {
    'scaleRange.scaleUpAt': {
      handler(newValue) {
        if (newValue) {
          this.updateScaleDownTime();
        }
      },
      deep: true,
    },
  },
  methods: {
    updateScaleDownTime() {
      if (this.scaleRange.scaleUpAt) {
        this.scaleRange.scaleDownAt = addMinutes(
          new Date(this.scaleRange.scaleUpAt),
          this.interval
        );
      }
    },
    scalePods() {
      this.$swal
        .fire({
          icon: 'question',
          text: `Confirm scaling of pods?`,
        })
        .then(async (res) => {
          if (res.isConfirmed) {
            let pass = {};
            Object.entries(this.pods).forEach(([prop, val]) => {
              pass[prop] = val;
            });

            try {
              let logs = {
                interval: this.interval,
                scale_up_time:
                  this.scaleOption === 'Scale Later'
                    ? format(
                        new Date(this.scaleRange.scaleUpAt),
                        'yyyy-MM-dd HH:mm:ss'
                      )
                    : format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                scaled_up_value: JSON.stringify(pass),
              };

              if (
                this.scaleOption === 'Scale Later' &&
                new Date(this.scaleRange.scaleUpAt) < new Date()
              ) {
                this.$swal.fire({
                  icon: 'error',
                  title: 'Error',
                  text: 'Scale up time must be later than current time.',
                });
                return;
              }

              if (this.scaleOption === 'Scale Now') {
                await this.$store.dispatch('scalePods', pass);
              }

              await this.$store.dispatch('updateScalePodsLog', logs);
              this.$refs.pnScalePodSchedule.getScaleSchedules();
            } catch (error) {
              console.error('Error scaling pods:', error);
            }
          }
        });
    },
  },
};
</script>
